/*
 * BeeCaramulo Apiturismo - v0.1.0
 * Author: truebond.pt
 * 
 * Page Header Data
 */

import masthead1Img320w from '../assets/img/bg-masthead-1-320w.jpg';
import masthead2Img320w from '../assets/img/bg-masthead-2-320w.jpg';
import masthead3Img320w from '../assets/img/bg-masthead-3-320w.jpg';

import masthead1Img480w from '../assets/img/bg-masthead-1-480w.jpg';
import masthead2Img480w from '../assets/img/bg-masthead-2-480w.jpg';
import masthead3Img480w from '../assets/img/bg-masthead-3-480w.jpg';

import masthead1Img640w from '../assets/img/bg-masthead-1-640w.jpg';
import masthead2Img640w from '../assets/img/bg-masthead-2-640w.jpg';
import masthead3Img640w from '../assets/img/bg-masthead-3-640w.jpg';

import masthead1Img800w from '../assets/img/bg-masthead-1-800w.jpg';
import masthead2Img800w from '../assets/img/bg-masthead-2-800w.jpg';
import masthead3Img800w from '../assets/img/bg-masthead-3-800w.jpg';

import masthead1Img from '../assets/img/bg-masthead-1.jpg';
import masthead2Img from '../assets/img/bg-masthead-2.jpg';
import masthead3Img from '../assets/img/bg-masthead-3.jpg';

// Next-gen formats include WebP, JPEG 2000 and JPEG XR. Those image formats possess superior compression (making images even lighter than JPEG and PNG) without losing in quality.

// WebP
import masthead1ImgWebp320w from '../assets/img/bg-masthead-1-320w.webp';
import masthead2ImgWebp320w from '../assets/img/bg-masthead-2-320w.webp';
import masthead3ImgWebp320w from '../assets/img/bg-masthead-3-320w.webp';

import masthead1ImgWebp480w from '../assets/img/bg-masthead-1-480w.webp';
import masthead2ImgWebp480w from '../assets/img/bg-masthead-2-480w.webp';
import masthead3ImgWebp480w from '../assets/img/bg-masthead-3-480w.webp';

import masthead1ImgWebp640w from '../assets/img/bg-masthead-1-640w.webp';
import masthead2ImgWebp640w from '../assets/img/bg-masthead-2-640w.webp';
import masthead3ImgWebp640w from '../assets/img/bg-masthead-3-640w.webp';

import masthead1ImgWebp800w from '../assets/img/bg-masthead-1-800w.webp';
import masthead2ImgWebp800w from '../assets/img/bg-masthead-2-800w.webp';
import masthead3ImgWebp800w from '../assets/img/bg-masthead-3-800w.webp';

import masthead1ImgWebp from '../assets/img/bg-masthead-1.webp';
import masthead2ImgWebp from '../assets/img/bg-masthead-2.webp';
import masthead3ImgWebp from '../assets/img/bg-masthead-3.webp';

export const PAGEHEADER = {
    scope: 'bee.Hero',
    sliderItems: [
        {
            altText: 'Slide 1',
            header: 'Bem-vindo à Beecaramulo',
            caption: 'O seu refúgio na Serra do Caramulo.',
            key: 1,
            src320: masthead1Img320w,
            src480: masthead1Img480w,
            src640: masthead1Img640w,
            src800: masthead1Img800w,
            src: masthead1Img,
            srcWebp320: masthead1ImgWebp320w,
            srcWebp480: masthead1ImgWebp480w,
            srcWebp640: masthead1ImgWebp640w,
            srcWebp800: masthead1ImgWebp800w,
            srcWebp: masthead1ImgWebp,
        },
        {
            altText: 'Slide 2',
            header: 'Sinta-se em Casa',
            caption: 'Desligue-se do mundo exterior, relaxe ao som do crepitar do fogo, delicie-se com a dança da chama.',
            key: 2,
            src320: masthead2Img320w,
            src480: masthead2Img480w,
            src640: masthead2Img640w,
            src800: masthead2Img800w,
            src: masthead2Img,
            srcWebp320: masthead2ImgWebp320w,
            srcWebp480: masthead2ImgWebp480w,
            srcWebp640: masthead2ImgWebp640w,
            srcWebp800: masthead2ImgWebp800w,
            srcWebp: masthead2ImgWebp,
        },
        {
            altText: 'Slide 3',
            header: 'Perfeito para Relaxar',
            caption: 'Todos os detalhes contam para lhe proporcionar uma experiência única.',
            key: 3,
            src320: masthead3Img320w,
            src480: masthead3Img480w,
            src640: masthead3Img640w,
            src800: masthead3Img800w,
            src: masthead3Img,
            srcWebp320: masthead3ImgWebp320w,
            srcWebp480: masthead3ImgWebp480w,
            srcWebp640: masthead3ImgWebp640w,
            srcWebp800: masthead3ImgWebp800w,
            srcWebp: masthead3ImgWebp,
        }
    ]
}